/** @description 自社商品フォルダか他社商品フォルダ */
export enum FolderTypeEnum {
  OWN = '01',
  OTHER = '02',
}
